var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEndVisit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Check badge",
    clipPath: "url(#clip0_4778_28271)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.66679 10.147C6.66679 9.36903 6.97584 8.62293 7.52595 8.07282C8.07605 7.52272 8.82216 7.21367 9.60013 7.21367H10.9335C11.708 7.21323 12.4509 6.90647 13.0001 6.36033L13.9335 5.427C14.2061 5.15287 14.5302 4.93532 14.8871 4.78688C15.2441 4.63843 15.6269 4.56201 16.0135 4.56201C16.4001 4.56201 16.7828 4.63843 17.1398 4.78688C17.4968 4.93532 17.8209 5.15287 18.0935 5.427L19.0268 6.36033C19.5761 6.907 20.3201 7.21367 21.0935 7.21367H22.4268C23.2048 7.21367 23.9509 7.52272 24.501 8.07282C25.0511 8.62293 25.3601 9.36903 25.3601 10.147V11.4803C25.3601 12.2537 25.6668 12.9977 26.2135 13.547L27.1468 14.4803C27.4209 14.7529 27.6385 15.077 27.7869 15.434C27.9354 15.791 28.0118 16.1737 28.0118 16.5603C28.0118 16.9469 27.9354 17.3297 27.7869 17.6867C27.6385 18.0436 27.4209 18.3677 27.1468 18.6403L26.2135 19.5737C25.6673 20.1229 25.3606 20.8658 25.3601 21.6403V22.9737C25.3601 23.7516 25.0511 24.4977 24.501 25.0478C23.9509 25.598 23.2048 25.907 22.4268 25.907H21.0935C20.3189 25.9074 19.576 26.2142 19.0268 26.7603L18.0935 27.6937C17.8209 27.9678 17.4968 28.1853 17.1398 28.3338C16.7828 28.4822 16.4001 28.5587 16.0135 28.5587C15.6269 28.5587 15.2441 28.4822 14.8871 28.3338C14.5302 28.1853 14.2061 27.9678 13.9335 27.6937L13.0001 26.7603C12.4509 26.2142 11.708 25.9074 10.9335 25.907H9.60013C8.82216 25.907 8.07605 25.598 7.52595 25.0478C6.97584 24.4977 6.66679 23.7516 6.66679 22.9737V21.6403C6.66635 20.8658 6.3596 20.1229 5.81346 19.5737L4.88013 18.6403C4.60599 18.3677 4.38845 18.0436 4.24 17.6867C4.09156 17.3297 4.01514 16.9469 4.01514 16.5603C4.01514 16.1737 4.09156 15.791 4.24 15.434C4.38845 15.077 4.60599 14.7529 4.88013 14.4803L5.81346 13.547C6.3596 12.9978 6.66635 12.2549 6.66679 11.4803V10.147Z",
    fill: "#19BB7A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12 16.547L14.6667 19.2137L20 13.8804",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4778_28271"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.546875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndVisit);
export default __webpack_public_path__ + "static/media/end-visit.c34d49fbac0e57cb2d888e41b7bb0d82.svg";
export { ForwardRef as ReactComponent };